import { Outlet, Link, useLocation, Navigate, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PermissionGuard } from '@/components/PermissionGuard';
import { areInternalSettingsTabsEnabled } from '@/utils/environment';

export default function Settings() {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const showInternalSettingsTabs = areInternalSettingsTabsEnabled();

  if (/^\/app\/settings\/?$/.test(location.pathname)) {
    return <Navigate to="/app/settings/account" />;
  }

  if (
    !showInternalSettingsTabs &&
    (currentPath.startsWith('/app/settings/sources') ||
      currentPath.startsWith('/app/settings/content'))
  ) {
    return <Navigate to="/app/settings/account" replace />;
  }

  const isUsersManagement = currentPath === '/app/settings/users';

  if (isUsersManagement) {
    return (
      <div className="mx-auto w-full min-w-0 max-w-[1440px] px-4 py-6 md:px-8">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="container py-6">
      <div className="flex items-center gap-2 mb-6">
        <div
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 cursor-pointer text-sm text-gray-600 hover:text-gray-900 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar
        </div>
      </div>
      <div className="space-y-2 border-b pb-6">
        <h1 className="text-3xl font-bold text-gray-900">Configurações</h1>
        <p className="text-gray-600">Gerencie as suas configurações</p>
      </div>
      <div className="mt-6 mb-12 overflow-x-auto">
        <div className="inline-flex h-auto items-center justify-center rounded-md bg-transparent p-0 text-muted-foreground min-w-max">
          <Link
            to="/app/settings/account"
            className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${currentPath === '/app/settings/account'
                ? 'bg-[#F5F5F5] text-foreground'
                : 'text-muted-foreground hover:text-foreground'
              }`}
          >
            Minha conta
          </Link>
          <PermissionGuard action="view_partners">
            <Link
              to="/app/settings/partners"
              className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${currentPath.startsWith('/app/settings/partners')
                  ? 'bg-[#F5F5F5] text-foreground'
                  : 'text-muted-foreground hover:text-foreground'
                }`}
            >
              Marcas
            </Link>
          </PermissionGuard>
          {showInternalSettingsTabs && (
            <PermissionGuard action="view_sources">
              <Link
                to="/app/settings/sources"
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${currentPath.startsWith('/app/settings/sources')
                    ? 'bg-[#F5F5F5] text-foreground'
                    : 'text-muted-foreground hover:text-foreground'
                  }`}
              >
                Fontes de conteúdo (APIs)
              </Link>
            </PermissionGuard>
          )}
          {showInternalSettingsTabs && (
            <PermissionGuard action="view_content">
              <Link
                to="/app/settings/content"
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${currentPath.startsWith('/app/settings/content')
                    ? 'bg-[#F5F5F5] text-foreground'
                    : 'text-muted-foreground hover:text-foreground'
                  }`}
              >
                Administração de conteúdos
              </Link>
            </PermissionGuard>
          )}
        </div>
      </div>
      <Outlet />
    </div>
  );
}
